export const FormSchema = {
  vehicles: {
    label: 'Véhicule(s)',
    message: 'Les macarons seront automatiquement générés au format PDF lorsque votre déclaration sera approuvée. Ceux-ci seront valables un jour avant la date de début de votre événement et un jour après la date de fin de celui-ci.',
    add: 'Ajouter un véhicule',
    yesOrNo: {
      label: 'Avez-vous besoin qu\'un ou plusieurs véhicules traversent la forêt (autre que les véhicules qui rejoignent l\'événement) ?',
    },
    license: {
      label: 'Plaque d\'immatriculation du véhicule',
      value: 'license',
      placeholder: 'Veuillez saisir l\'immatriculation du véhicule',
      error: 'Veuillez saisir l\'immatriculation du véhicule',
    },
  },
  affiliation: [
    { label: 'Fédération française de course d\'orientation', value: 'FFCO' },
    { label: 'Fédération française de randonnée pédestre', value: 'FFRP' },
    { label: 'Fédération française de cyclotourisme', value: 'FFCT' },
    { label: 'Fédération française de cyclisme', value: 'FFC' },
    { label: 'Fédération française d\'équitation', value: 'FFE' },
    { label: 'Fédération française des sports populaires', value: 'FFSP' },
  ],
};

export default FormSchema;



// WEBPACK FOOTER //
// ./src/components/Form/FormSchema.js